export enum MessageTypeName {
    CheckedInCustomer_WalkIn = 'CheckedInCustomer_WalkIn',
    CheckedInCustomer_Appointment = 'CheckedInCustomer_Appointment',
    Customer_NextInQueue = 'Customer_NextInQueue',
}